import React from 'react';
import styled from 'styled-components';
import { Switch } from '@increasecard/typed-components';
import { useShallowEqualSelector } from '../../../utils/reduxUtils';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useModal } from '@card/commonlib';
import { useEventTracker } from '@increasecard/increase-core';
import { ConfirmAutoRenewalModal } from '../../credentials/components/ConfirmAutoRenewalModal';
import { CredentialsActions } from '../../credentials/actions';

// TODO(santi698): Remove `width: max-content` from switch in @increasecard/typed-components
const SwitchWrapper = styled.div`
  > * {
    max-width: 100%;
  }
`;

export function AutorenewAllToggle() {
  const { t } = useTranslation();
  const tracker = useEventTracker();
  const autoRenewalModal = useModal();
  const dispatch = useDispatch();
  const autoRenewAllCredentials = useShallowEqualSelector(
    (state) => state.credentials.autoRenewAllCredentials
  );

  const setAutoRenewAll = (value: boolean) => {
    tracker.track(`All Credentials Automatic renewal ${!autoRenewAllCredentials ? 'on' : 'off'}`);
    dispatch(CredentialsActions.autoRenewAllCredentials(value));
  };

  const onToggleRenewAll = () => {
    const activating = autoRenewAllCredentials === false;
    if (activating) {
      autoRenewalModal.open();
      return;
    }

    setAutoRenewAll(false);
  };
  return (
    <>
      <SwitchWrapper>
        <Switch
          checked={autoRenewAllCredentials}
          id="autorenewalSwitch"
          label={t(`abm:Shops:autorenewalText`)}
          onChange={onToggleRenewAll}
          size="small"
        />
      </SwitchWrapper>
      <ConfirmAutoRenewalModal
        onClose={() => autoRenewalModal.close()}
        onConfirm={() => {
          autoRenewalModal.close();
          setAutoRenewAll(true);
        }}
        visible={autoRenewalModal.isOpen}
      />
    </>
  );
}
